export default {
  name: 'patient-list-list',
  data () {
    return {
    }
  },
  props: {
    patients: Array,
    sortBy: Function,
    getArrow: Function
  },
  computed: {
    orderedPatients () {
      return this.patients
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    }
  },
  methods: {
    goPlan: function(facilityId, patientId) {
      this.$router.push({ path: '/patients/plan/' + facilityId + '/' + patientId})
    },
    goReport: function(facilityId, patientId) {
      this.$router.push({ path: '/patients/report/' + facilityId + '/' + patientId})
    },
    /** 画像押下 */
    onClickImageModalShow: function (patient) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = patient.attributes['avartar-path'] + '?token=' + this.authToken
      text.textContent = ''
      button.click()
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/patient-list-list.js